import { Box, Paper, Skeleton, Stack, Typography } from "@mui/material";
import TableSkeleton from "@components/shared/loading/TableSkeleton";
import BoxRow from "./BoxRow";
import BarChart from "./BarChart";
import TeamTable from "./TeamTable";
import DateRangePicker from "./DateRangePicker";
import StatsRangeHeading from "./StatsRangeHeading";
import { DASHBOARD_FOCUS } from "@lib/enums";
import getDashboardFocusConfig from "@lib/dashboard/dashboardFocus";

export default function Stats({
  isTeam,
  focus = DASHBOARD_FOCUS.FLOATS,
  stats,
  fixedStats,
  chartStats,
  tableStats,
  chartLoading,
  tableLoading,
  statsLoading,
  statsRange,
  onStatsRangeChange,
  chartRange,
  tableRange,
  onChartRangeChange,
  onTableRangeChange,
}) {
  const statsBoxSx = {
    opacity: statsLoading ? 0.65 : 1,
    transition: "opacity 0.2s ease-in-out",
  };
  const config = getDashboardFocusConfig(focus);

  if (isTeam) {
    return (
      <Box component="main">
        <StatsRangeHeading value={statsRange} onChange={onStatsRangeChange} />
        {fixedStats && (
          <Box sx={statsBoxSx}>
            <BoxRow stats={fixedStats.total} focus={focus} />
          </Box>
        )}
        <Stack
          direction={{ xs: "column", md: "row" }}
          spacing={3}
          sx={{ mt: 8 }}
        >
          <Box sx={{ flex: 1, display: "flex", flexDirection: "column" }}>
            <Typography variant="h2" sx={{ mb: 2 }}>
              {config.chartTitle}
            </Typography>
            <DateRangePicker
              value={chartRange}
              onChange={onChartRangeChange}
            />
            <Paper
              sx={{ p: 2, flex: 1, display: "flex", flexDirection: "column" }}
            >
              <Box sx={{ flex: 1, minHeight: 250 }}>
                {chartLoading ? (
                  <Skeleton
                    variant="rectangular"
                    width="100%"
                    height={250}
                    sx={{ borderRadius: 1 }}
                  />
                ) : (
                  chartStats && <BarChart data={chartStats.time_series} />
                )}
              </Box>
            </Paper>
          </Box>
          <Box sx={{ flex: 1, display: "flex", flexDirection: "column" }}>
            <Typography variant="h2" sx={{ mb: 2 }}>
              Leaderboard
            </Typography>
            <DateRangePicker
              value={tableRange}
              onChange={onTableRangeChange}
            />
            <Paper sx={{ flex: 1 }}>
              {tableLoading ? (
                <TableSkeleton />
              ) : (
                tableStats && <TeamTable stats={Object.values(tableStats.team)} />
              )}
            </Paper>
          </Box>
        </Stack>
      </Box>
    );
  }

  if (!stats) return null;
  return (
    <Box component="main">
      <StatsRangeHeading value={statsRange} onChange={onStatsRangeChange} />
      <Box sx={statsBoxSx}>
        <BoxRow stats={stats.total} focus={focus} />
      </Box>
    </Box>
  );
}
